import { GET_GUEST_USER, REMOVE_GUEST_USER } from '../actions/types';

const initialState = {
  userid: '',
};

function reducer(state = initialState, action: { type: string; payload?: any }) {
  switch (action.type) {
    case GET_GUEST_USER:
      return {
        ...state,
        userid: action.payload,
      };
    case REMOVE_GUEST_USER:
      return {
        ...state,
        userid: '',
      };
    default:
      return state;
  }
}

export default reducer;
